var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import BackrsFilledDropShadow from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { AnimatedCollapse } from '@backrs_ui/common-ui/src/atoms/AnimatedCollapse';
import { AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { TYPOGRAPHY_VARIANTS } from '@backrs_ui/common-ui/src/designSystem/typography/typography';
import { Box, ClickAwayListener, TextField, Typography } from '@mui/material';
import { ProfilePopupWidget } from './ProfilePopupWidget';
import { SidebarItem } from './SidebarItem';
export var SIDEBAR_COLLAPSED_WIDTH = 72;
export var SIDEBAR_EXPANDED_WIDTH = 296;
var SIDEBAR_COLLAPSED_WIDTH_WITH_SCROLLBAR = 80;
var SIDEBAR_STRINGS = appStrings.modules.backrsSidebar;
export var BackrsSidebar = function (_a) {
    var _b;
    var sidebar = _a.sidebar;
    var _c = useState(false), isSideBarOpen = _c[0], setIsSideBarOpen = _c[1];
    var _d = useState(), expandedItem = _d[0], setExpandedItem = _d[1];
    var handleSettingExpandedItem = function (itemName, shouldOpenSidebar) {
        if (shouldOpenSidebar) {
            setIsSideBarOpen(true);
        }
        setExpandedItem(itemName);
    };
    var handleToggleSidebar = function () {
        setIsSideBarOpen(function (prev) { return !prev; });
        setExpandedItem(undefined);
    };
    var handleSearchEnterKey = function (event) {
        if (event.key === 'Enter') {
            var value = event.target.value;
            sidebar.search.onSearch(value);
            event.target.value = '';
            setIsSideBarOpen(false);
        }
    };
    var unAuthUser = (_b = sidebar.user) === null || _b === void 0 ? void 0 : _b.isUnauthenticated;
    return (_jsx(ClickAwayListener, { onClickAway: function () { return setIsSideBarOpen(false); }, children: _jsxs(Box, { sx: containerSx(isSideBarOpen), children: [_jsxs(Box, { sx: contentContainerSx(isSideBarOpen), children: [_jsxs(Box, { sx: logoContainerSx(isSideBarOpen), onClick: handleToggleSidebar, children: [_jsx(Box, { component: "img", src: BackrsFilledDropShadow, alt: "Backrs Logo", sx: backrsLogoImageSx(isSideBarOpen) }), _jsx(AnimatedCollapse, { isOpen: isSideBarOpen, direction: "horizontal", opacityFade: true, children: _jsx(Typography, { variant: "display-lg-semibold", children: SIDEBAR_STRINGS.backrs }) })] }), !unAuthUser ? (_jsx(TextField, { variant: "outlined", placeholder: SIDEBAR_STRINGS.search, sx: searchBarSx(isSideBarOpen, sidebar.search.isPageActive), onClick: isSideBarOpen ? undefined : function () { return sidebar.search.onSearch(); }, onKeyDown: handleSearchEnterKey, InputProps: {
                                startAdornment: (_jsx(Box, { sx: expandedSearchIconAdornmentSx(isSideBarOpen), children: _jsx(AppIcon, { iconName: "SearchMd", diameter: "20px", color: "Colors/Background/bg-primary-solid" }) })),
                            } })) : null, sidebar.sections.map(function (section, index) { return (_jsxs(Box, { sx: sidebarSectionSx, children: [section.menuItems.map(function (item, index) { return (_jsx(SidebarItem, { sidebarMenuItem: item, expandedItem: expandedItem, setExpandedItem: handleSettingExpandedItem, isSidebarOpen: isSideBarOpen, setIsSideBarOpen: setIsSideBarOpen }, index)); }), index !== sidebar.sections.length - 1 && !unAuthUser && (_jsx(Box, { sx: sectionBottomBorderSx }))] }, index)); })] }), _jsx(Box, { sx: profileWidgetContainerSx(isSideBarOpen), children: _jsx(ProfilePopupWidget, { backrsUser: sidebar.user, isSidebarOpen: isSideBarOpen, topSectionItems: sidebar.accountMenuItems.topSectionItems, bottomSectionItems: sidebar.accountMenuItems.bottomSectionItems }) })] }) }));
};
var containerSx = function (isSideBarOpen) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            height: '100dvh',
            borderRight: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            width: isSideBarOpen ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH,
            transition: 'all 0.3s ease-in-out',
            overflow: 'none',
            backgroundColor: backrs.colors['Beige/50'],
            paddingBottom: isSideBarOpen ? backrs.spacing['spacing-2xl'] : backrs.spacing['spacing-3xl'],
            '@media screen and (min-width: 768px) and (max-width: 1366px) and (max-height: 700px)': {
                width: isSideBarOpen ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH_WITH_SCROLLBAR,
            },
            '@media screen and (max-width: 600px)': {
                width: isSideBarOpen ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH,
            },
        });
    };
};
var profileWidgetContainerSx = function (isSideBarOpen) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            paddingLeft: isSideBarOpen ? backrs.spacing['spacing-2xl'] : backrs.spacing['spacing-lg'],
            paddingRight: isSideBarOpen ? backrs.spacing['spacing-xl'] : backrs.spacing['spacing-lg'],
            transition: 'all 0.3s ease-in-out',
        });
    };
};
var contentContainerSx = function (isSideBarOpen) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            gap: backrs.spacing['spacing-sm'],
            paddingTop: isSideBarOpen ? backrs.spacing['spacing-2xl'] : backrs.spacing['spacing-xl'],
            paddingBottom: backrs.spacing['spacing-lg'],
            paddingLeft: isSideBarOpen ? backrs.spacing['spacing-2xl'] : backrs.spacing['spacing-lg'],
            paddingRight: isSideBarOpen ? backrs.spacing['spacing-xl'] : backrs.spacing['spacing-lg'],
            transition: 'all 0.3s ease-in-out',
        });
    };
};
var logoContainerSx = function (isSideBarOpen) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            gap: backrs.spacing['spacing-2xl'],
            display: 'flex',
            marginBottom: isSideBarOpen ? backrs.spacing['spacing-2xl'] : backrs.spacing['spacing-3xl'],
            transition: 'all 0.3s ease-in-out',
            minHeight: ICON_SIZES['64px'],
        });
    };
};
var searchBarSx = function (isSideBarOpen, isPageActive) {
    return function (_a) {
        var backrs = _a.backrs;
        var collapsedSidebarBorder = isPageActive
            ? backrs.colors['Colors/Base/Black']
            : backrs.colors['Colors/Base/Transparent'];
        var expandedSidebarBorder = backrs.colors['Gray/300'];
        var searchBarBorder = isSideBarOpen ? expandedSidebarBorder : collapsedSidebarBorder;
        return {
            mb: backrs.spacing['spacing-xl'],
            display: 'flex',
            justifyContent: 'center',
            transition: 'all 0.3s ease-in-out',
            borderRadius: backrs.radius['radius-sm'],
            width: isSideBarOpen ? '100%' : 'auto',
            minWidth: backrs.spacing['spacing-5xl'],
            minHeight: backrs.spacing['spacing-5xl'],
            maxWidth: !isSideBarOpen ? '48px' : 'unset',
            '& .MuiOutlinedInput-root': {
                maxWidth: isSideBarOpen ? SIDEBAR_EXPANDED_WIDTH : '48px',
                minWidth: '48px',
                paddingY: backrs.spacing['spacing-md'],
                paddingX: backrs.spacing['spacing-lg'],
                borderRadius: backrs.radius['radius-md'],
                border: "1px solid ".concat(searchBarBorder),
                backgroundColor: !isSideBarOpen && isPageActive
                    ? backrs.colors['Colors/Background/bg-primary']
                    : 'transparent',
                transition: "max-width 0.3s ease-in-out, background-color 0.3s ease-in-out, border 0.3s ease-in-out",
                gap: backrs.spacing['spacing-lg'],
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: '1px solid transparent !important',
                },
                cursor: isSideBarOpen ? 'default' : 'pointer',
                '&.Mui-focused': __assign({}, (isSideBarOpen
                    ? {
                        borderColor: backrs.colors['Colors/Border/border-brand'],
                    }
                    : {
                        boxShadow: "0 0 0 1px transparent !important",
                        border: "1px solid ".concat(searchBarBorder, " !important"),
                    })),
                '&:active': {
                    transition: 'all 0.3s ease-in-out',
                    border: "1px solid ".concat(backrs.colors['Colors/Border/border-brand']),
                },
            },
            '&:hover': !isSideBarOpen
                ? {
                    backgroundColor: backrs.colors['Colors/Background/bg-primary'],
                    transform: 'translate(-2px, -2px)',
                    boxShadow: '4px 4px 0px 0px rgba(0, 0, 0, 1)',
                }
                : {},
            '&:active': {
                transform: 'none !important',
                boxShadow: 'none !important',
                transition: 'all 0s !important',
            },
            '&:hover .MuiOutlinedInput-root': !isPageActive && !isSideBarOpen
                ? {
                    border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
                }
                : {},
            '&:active .MuiOutlinedInput-root': {
                boxShadow: 'none !important',
                transition: 'all 0s !important',
                transform: 'none !important',
            },
            '& .MuiOutlinedInput-input': {
                color: backrs.colors['Colors/Text/text-primary'],
                padding: backrs.spacing['spacing-none'],
                fontWeight: TYPOGRAPHY_VARIANTS['text-md-regular'].fontWeight,
                fontSize: TYPOGRAPHY_VARIANTS['text-md-regular'].fontSize,
                display: 'flex',
                borderRadius: backrs.radius['radius-sm'],
                border: 'none',
                '&::placeholder': {
                    color: isSideBarOpen ? backrs.colors['Colors/Text/text-placeholder'] : 'transparent',
                    transition: 'all 0.3s ease-in-out',
                    opacity: 1,
                },
            },
            '& input:-webkit-autofill': {
                transition: 'background-color 600000s 0s, color 600000s 0s',
            },
            '& .MuiInputLabel-outlined': {
                color: backrs.colors['Colors/Text/text-primary'],
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        };
    };
};
var expandedSearchIconAdornmentSx = function (isSideBarOpen) {
    return function () { return ({
        minWidth: ICON_SIZES['20px'],
        minHeight: ICON_SIZES['20px'],
        display: 'flex',
        alignItems: 'center',
        cursor: isSideBarOpen ? 'default' : 'pointer',
    }); };
};
var sidebarSectionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-sm'],
        display: 'flex',
        flexDirection: 'column',
    });
};
var sectionBottomBorderSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Border/border-primary']),
        my: backrs.spacing['spacing-xs'],
        mx: backrs.spacing['spacing-md'],
    });
};
var backrsLogoImageSx = function (isSideBarOpen) {
    return function () { return ({
        cursor: 'pointer',
        height: isSideBarOpen ? ICON_SIZES['64px'] : ICON_SIZES['48px'],
        width: isSideBarOpen ? ICON_SIZES['64px'] : ICON_SIZES['48px'],
        transition: 'height 0.3s, width 0.3s',
    }); };
};
